import { api } from "../api";

export async function ensureWhatsappFlowLinked({ customerId, flowId }) {
  if (!flowId) return null;

  const flowIdNumber = Number(flowId);

  try {
    const existingWhatsappFlow = await api.whatsappFlow.maybeFindFirst({
      filter: {
        customerId: { equals: customerId },
        flowId: { equals: flowIdNumber },
      },
      select: { id: true },
    });

    if (existingWhatsappFlow) {
      return existingWhatsappFlow.id;
    }

    const flowDetails = await api.settings.getWhatsappFlowDetails({
      customerId,
      flowId: String(flowIdNumber),
    });

    const newWhatsappFlow = await api.whatsappFlow.create({
      name: flowDetails.name,
      flowId: flowIdNumber,
      customer: { _link: customerId },
    });

    await api.settings.syncWhatsappFlowScreens({
      whatsappFlowId: newWhatsappFlow.id,
    });

    return newWhatsappFlow.id;
  } catch (e) {
    console.error(`Error syncing WhatsApp flow ${flowId}:`, e);
    return null;
  }
}
